import { useAutocompleteSource } from '@eas/common-web';
import { DictOpponentAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useOpponents() {
  return useAutocompleteSource<DictOpponentAutocomplete>({
    url: `${EvidenceApiUrl.DICT_OPPONENTS}/autocomplete`,
  });
}
